import React from 'react';
import AuthService from './authService.js';

class StoredJsonDataService extends React.Component
{

    static postStoredJsonData(name,type,data)
    {
        let dataJSON=JSON.stringify({
            Name:name,
            Type:type,
            JsonData:JSON.stringify(data)
        });


        var authService = AuthService.getInstance();

        var url = "/api/StoredJsonData/SaveStoredJsonData/";

        return authService.CallBackendFunctionPost(url, dataJSON);
    }

    static getExistingNames(type)
    {
        var authService = AuthService.getInstance();
        var url = `/api/StoredJsonData/GetExistingNames/?type=${type}`;
        return authService.CallBackendFunction(url);
    }

    static getDataByNameAndType(name,type)
    {
        var authService = AuthService.getInstance();
        var url = `/api/StoredJsonData/GetDataByNameAndType/?type=${type}&&name=${name}`;
        return authService.CallBackendFunction(url);
    }

    static deleteDataByNameAndType(name,type)
    {
        var authService = AuthService.getInstance();
        var url = `/api/StoredJsonData/DeleteDataByNameAndType/?type=${type}&&name=${name}`;
        return authService.CallBackendFunctionDelete(url);
    }


}

export default StoredJsonDataService;